import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
  Form,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import hasUserInfo from '../../hocs/has-user-info';

const messageStyles = {
  width: '100%',
};
class CampaignEcommerceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      ..._.get(props, 'ecommerceSettings', {}),
      contentChaseEmailSubject: _.get(props, 'ecommerceSettings.contentChaseEmail.subject', ''),
      contentChaseEmailTemplate: _.get(props, 'ecommerceSettings.contentChaseEmail.template', ''),
    };
  }
  onInputChanged = (event, { name, value, checked }) => {
    this.setState({
      [name]: value || checked,
    });
  }

  handleFormSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;

    this.setState({ error: null });
    const {
      shopifyAccessToken,
      shopifyShopUrl,
      freeProductPriceRule,
      freeShippingPriceRule,
      emailSubject,
      emailTemplate,
      discountCodeStem,
      freeShippingCodeStem,
      brandName,
      shopifyStoreLink,
      productOrderText,
      fromEmail,
      contentChaseEmailSubject,
      contentChaseEmailTemplate } = this.state;

    const payload = {
      shopifyAccessToken,
      shopifyShopUrl,
      freeProductPriceRule,
      freeShippingPriceRule,
      emailSubject,
      emailTemplate,
      discountCodeStem,
      freeShippingCodeStem,
      brandName,
      shopifyStoreLink,
      productOrderText,
      fromEmail,
      contentChaseEmail: {
        subject: contentChaseEmailSubject,
        template: contentChaseEmailTemplate,
      },
    };

    const errors = _.reduce(_.keys(payload), (acc, key) => {
      const value = payload[key];
      const isValid = !_.isEmpty(value); // TODO: Implement validation
      if (!isValid) {
        acc[key] = 'Field is required';
      }
      return acc;
    }, {});
    this.setState({ errors });

    const isValid = _.isEmpty(errors);
    if (isValid) {
      onSubmit(payload);
    }
  }

  render() {
    const {
      onClose,
      isSubmitting,
      error,
    } = this.props;

    const {
      shopifyAccessToken,
      shopifyShopUrl,
      freeProductPriceRule,
      freeShippingPriceRule,
      emailSubject,
      emailTemplate,
      discountCodeStem,
      freeShippingCodeStem,
      brandName,
      shopifyStoreLink,
      productOrderText,
      fromEmail,
      contentChaseEmailSubject,
      contentChaseEmailTemplate,
      errors,
    } = this.state;
    return (
      <div>
        <DyzioModal headerText="Ecommerce Settings" size="small" onClose={onClose}>
          <div >
            {error && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  // margin: '20px',
                }}
              >
                <Message
                  fluid
                  style={messageStyles}
                  icon="frown"
                  error
                  header="Error"
                  content="Something went wrong. Please try again later."
                />
              </div>
            )}

            <Form onSubmit={this.handleFormSubmit}>
              <div style={{ maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' }}>
                <Form.Field disabled>
                  <label htmlFor="shopifyAccessToken">Access Token</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'shopifyAccessToken'))}
                    placeholder="Shopify Access Token"
                    name="shopifyAccessToken"
                    id="shopifyAccessToken"
                    value={shopifyAccessToken}
                  />
                </Form.Field>
                <Form.Field disabled>
                  <label htmlFor="shopifyShopUrl">Shop Url</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'shopifyShopUrl'))}
                    placeholder="Shopify Shop Url"
                    id="shopifyShopUrl"
                    name="shopifyShopUrl"
                    value={shopifyShopUrl}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="freeProductPriceRule">Free product price rule</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'freeProductPriceRule'))}
                    onChange={this.onInputChanged}
                    placeholder="Free product price rule"
                    id="freeProductPriceRule"
                    name="freeProductPriceRule"
                    value={freeProductPriceRule}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="freeShippingPriceRule">Free shipping price rule</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'freeShippingPriceRule'))}
                    onChange={this.onInputChanged}
                    placeholder="Free shipping price rule"
                    id="freeShippingPriceRule"
                    name="freeShippingPriceRule"
                    value={freeShippingPriceRule}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="emailSubject">Email subject</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'emailSubject'))}
                    onChange={this.onInputChanged}
                    placeholder="Email subject"
                    id="emailSubject"
                    name="emailSubject"
                    value={emailSubject}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="emailTemplate">Email template</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'emailTemplate'))}
                    onChange={this.onInputChanged}
                    placeholder="Email template"
                    id="emailTemplate"
                    name="emailTemplate"
                    value={emailTemplate}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="discountCodeStem">Discount Code Stem</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'discountCodeStem'))}
                    onChange={this.onInputChanged}
                    placeholder="Discount Code Stem"
                    id="discountCodeStem"
                    name="discountCodeStem"
                    value={discountCodeStem}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="freeShippingCodeStem">Free shipping code stem</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'freeShippingCodeStem'))}
                    onChange={this.onInputChanged}
                    placeholder="Free shipping code stem"
                    id="freeShippingCodeStem"
                    name="freeShippingCodeStem"
                    value={freeShippingCodeStem}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="brandName">Brand name</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'brandName'))}
                    onChange={this.onInputChanged}
                    placeholder="Brand name"
                    id="brandName"
                    name="brandName"
                    value={brandName}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="shopifyStoreLink">Shopify Store Link</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'shopifyStoreLink'))}
                    onChange={this.onInputChanged}
                    placeholder="Shopify Store Link"
                    id="shopifyStoreLink"
                    name="shopifyStoreLink"
                    value={shopifyStoreLink}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="productOrderText">Product order text</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'productOrderText'))}
                    onChange={this.onInputChanged}
                    placeholder="Product order text"
                    id="productOrderText"
                    name="productOrderText"
                    value={productOrderText}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="fromEmail">From email</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'fromEmail'))}
                    onChange={this.onInputChanged}
                    placeholder="From email"
                    id="fromEmail"
                    name="fromEmail"
                    value={fromEmail}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="contentChaseEmailSubject">Content chase email subject</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'contentChaseEmailSubject'))}
                    onChange={this.onInputChanged}
                    placeholder="Content chase email subject"
                    id="contentChaseEmailSubject"
                    name="contentChaseEmailSubject"
                    value={contentChaseEmailSubject}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="contentChaseEmailTemplate">Content chase email template</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'contentChaseEmailTemplate'))}
                    onChange={this.onInputChanged}
                    placeholder="Content chase email template"
                    id="contentChaseEmailTemplate"
                    name="contentChaseEmailTemplate"
                    value={contentChaseEmailTemplate}
                  />
                </Form.Field>
              </div>
              <div
                className="flex"
                style={{
                  justifyContent: 'flex-end',
                  padding: '10px 0px 10px 0px',
                }}
              >
                <Form.Button
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  color="pink"
                  type="submit"
                  size="medium"
                >
                Submit
                </Form.Button>
              </div>
            </Form>

          </div>
        </DyzioModal>
      </div>
    );
  }
}

CampaignEcommerceModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.any,
};
CampaignEcommerceModal.defaultProps = {
  onClose: _.noop,
  onSubmit: _.noop,
  isSubmitting: false,
  error: null,
};
export default compose(
  hasUserInfo,
)(CampaignEcommerceModal);



/** WEBPACK FOOTER **
 ** ./src/components/campaign-ecommerce-modal/index.js
 **/